import { render, staticRenderFns } from "./ShipInspectionList.vue?vue&type=template&id=284deb10&scoped=true&"
import script from "./ShipInspectionList.vue?vue&type=script&lang=ts&"
export * from "./ShipInspectionList.vue?vue&type=script&lang=ts&"
import style0 from "./ShipInspectionList.vue?vue&type=style&index=0&id=284deb10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284deb10",
  null
  
)

export default component.exports